export default __webpack_public_path__ + "static/media/428.e6cc1025.png";